var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0407 0.915667C11.467 0.394874 12.3091 1.22192 11.8828 1.74271C9.51907 4.73727 7.13594 7.68843 4.75281 10.6613C4.63655 10.8132 4.5203 10.9434 4.40405 11.0953C4.22968 11.3123 3.9003 11.2906 3.72593 11.0953C2.52467 9.815 1.32342 8.51302 0.122169 7.23274C-0.323458 6.75534 0.560334 5.8984 1.00596 6.39749C2.09096 7.54757 2.93141 8.61921 4.01641 9.79099C6.41891 6.79643 8.65762 3.91023 11.0407 0.915667Z",
    fill: "#212329"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/ArrowIcon.46484a2740eb11172520b8fdb708ed8f.svg";
export { ForwardRef as ReactComponent };